<div id="content" class="dark help-page">
    <div>
        <img src="../../../../assets/img/app-logo-color.png" class="white-logo" />
        <img src="../../../../assets/img/app-logo.png" class="black-logo" />
        <p>In case of any query or concerns, please E-mail us at<br/>
            <a href="mailto:support@prideplex.com" style="cursor:default;text-decoration:none;">support@prideplex.com</a>
        </p>
    </div>
</div>